import { jsx as _jsx, jsxs as _jsxs } from "@redneckz/uni-jsx/jsx-runtime";
import { useCallback, useState } from '@redneckz/uni-jsx/lib/hooks';
import { useForm } from '../../hooks/useForm.js';
import { BlockWrapper } from '../../ui-kit/BlockWrapper.js';
import { NotFound } from '../../ui-kit/NotFound/NotFound.js';
import { Pagination } from '../../ui-kit/Pagination/Pagination.js';
import { Text } from '../../ui-kit/Text/Text.js';
import { UniBlock } from '../../UniBlock/UniBlock.js';
import { style } from '../../utils/style.js';
import { DepositoryFilter } from './DepositoryFilter.js';
import { DepositoryItem } from './DepositoryItem.js';
import { useDepository } from './useDepository.js';
const DEFAULT_ITEMS_COUNT = 10;
const initialFiltrationState = {
    startDate: undefined,
    endDate: undefined,
    query: '',
};
export const Depository = UniBlock(({ className, ...rest }) => {
    const [currentPage, setCurrentPage] = useState(0);
    const [itemCount, setItemCount] = useState(DEFAULT_ITEMS_COUNT);
    const [filtrationState, { field, reset }] = useForm(initialFiltrationState);
    const { totalPages = 0, items = [] } = useDepository({
        size: itemCount,
        page: currentPage,
        ...filtrationState,
    });
    const handleChangePage = useCallback((page) => setCurrentPage(page - 1), []);
    const handleItemCountChange = useCallback((count) => {
        if (itemCount !== count) {
            setItemCount(count);
            setCurrentPage(0);
        }
        else {
            setItemCount(count);
        }
    }, []);
    return (_jsxs(BlockWrapper, { className: style(className, 'container p-6xl'), ...rest, children: [_jsx(DepositoryFilter, { filtrationState: filtrationState, field: field, onClearFilter: reset }), _jsxs("div", { className: "flex flex-col", children: [_jsxs("div", { className: "grid grid-cols-12 pb-lg border-gray border-opacity-50 border-b", children: [_jsx("div", { className: "col-span-4 @lg:col-span-2 hidden @lg:block", children: _jsx(Text, { size: "text-m", color: "text-secondary-text", children: "\u0414\u0430\u0442\u0430" }) }), _jsx("span", { className: "col-span-8 @lg:col-span-10 hidden @lg:block", children: _jsx(Text, { size: "text-m", color: "text-secondary-text", children: "\u0422\u0435\u043C\u0430" }) })] }), items.length ? (items.map((params) => _jsx(DepositoryItem, { ...params }, String(params.publicId)))) : (_jsx(NotFound, { title: "\u041D\u0438\u0447\u0435\u0433\u043E \u043D\u0435 \u043D\u0430\u0439\u0434\u0435\u043D\u043E", description: "\u041F\u043E\u043F\u0440\u043E\u0431\u0443\u0439\u0442\u0435 \u043E\u0447\u0438\u0441\u0442\u0438\u0442\u044C \u0444\u0438\u043B\u044C\u0442\u0440\u044B" })), _jsx(Pagination, { currentPage: currentPage + 1, onPageChange: handleChangePage, totalPages: totalPages, itemCount: itemCount, onItemCountChange: handleItemCountChange })] })] }));
});
//# sourceMappingURL=Depository.js.map